import { filter, orderBy } from "lodash/fp";

import type { UserDistributionSetting, UserSettings } from "@app/common/types";
import * as UserSettingsUtils from "@app/common/utils/userSettingsUtils";

export const getSettingsForCategory = (
  userSettings: UserSettings,
  category: UserDistributionSetting["category"]
): UserDistributionSetting[] => {
  return orderBy(
    "method",
    "asc",
    UserSettingsUtils.getUserDistributionSettingsForCategory(
      userSettings,
      category
    )
  );
};

export const getEnabledChannelSettings = (
  settings: UserDistributionSetting[]
) => filter({ isEnabled: true }, settings);

export type DistributionChannelDisabledReason =
  | "disabled_for_workspace" // integrating with this provider has been disabled by the Workspace
  | "not_connected"; // channel is tied to an integration that could be connected, but isn't currently

export const getChannelDisabledReason = ({
  isConnected,
  isDisabled,
}: {
  /* whether the integration is already connected */
  isConnected: boolean;
  /* whether the channel is disabled for the user (e.g., workspace has disabled that integration provider) */
  isDisabled: boolean;
}): DistributionChannelDisabledReason | undefined => {
  if (isDisabled) return "disabled_for_workspace";
  return isConnected ? undefined : "not_connected";
};
